import React, { useMemo, useState } from "react";
import { AppBar, Avatar, Badge, Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Toolbar, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { decryptWithAES } from "../../helper/crypto";
import { useLayoutContext } from "../../context/LayoutContext";

const routeTitles = [
  ["/leads/ads-tracking", "Ads Tracking"], ["/pricing/calculator", "Pricing Calculator"], ["/pricing/configs", "Pricing Configuration"],
  ["/listed-products", "Products"], ["/QManagement", "Quantity Management"], ["/edit-upload", "Edit Upload"],
  ["/dashboard", "Dashboard"], ["/analytics", "Analytics"], ["/pricing", "Pricing & Profit"], ["/orders", "Orders"],
  ["/wallet", "Wallet"], ["/remmitance", "Remittance"], ["/banner", "Banners"], ["/leads", "Leads"], ["/signup", "Create User"],
];

function readEmail() {
  try { return decryptWithAES(localStorage.getItem("email") || ""); } catch (_) { return ""; }
}

export default function Header() {
  const { setMobileDrawerOpen } = useLayoutContext();
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const email = useMemo(readEmail, []);
  const title = routeTitles.find(([path]) => location.pathname === path || location.pathname.startsWith(`${path}/`))?.[1] || "Admin";
  const initials = email ? email.slice(0, 2).toUpperCase() : "JT";

  const logout = () => {
    localStorage.removeItem("token"); localStorage.removeItem("res"); localStorage.removeItem("email");
    navigate("/login", { replace: true });
  };

  return <AppBar position="sticky" elevation={0} color="inherit" sx={{ borderBottom: "1px solid", borderColor: "divider", zIndex: (value) => value.zIndex.drawer + 1 }}>
    <Toolbar sx={{ minHeight: { xs: 60, sm: 64 }, px: { xs: 1.25, sm: 2.5 } }}>
      {mobile && <IconButton edge="start" aria-label="Open navigation" onClick={() => setMobileDrawerOpen(true)} sx={{ mr: 1 }}><MenuIcon /></IconButton>}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0, flex: 1 }}>
        {!mobile && <Box sx={{ width: 34, height: 34, borderRadius: 2, bgcolor: "primary.main", color: "white", display: "grid", placeItems: "center", fontWeight: 900, fontSize: 13 }}>JT</Box>}
        <Box sx={{ minWidth: 0 }}><Typography noWrap sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 800, lineHeight: 1.15 }}>{title}</Typography>{!mobile && <Typography variant="caption" color="text.secondary">Jusstools Admin Workspace</Typography>}</Box>
      </Box>
      <Tooltip title="Notifications"><IconButton aria-label="Notifications" sx={{ mr: .5 }}><Badge color="secondary" variant="dot"><NotificationsNoneRoundedIcon /></Badge></IconButton></Tooltip>
      <Tooltip title={email || "Account"}><IconButton aria-label="Open account menu" onClick={(event) => setAnchorEl(event.currentTarget)}><Avatar sx={{ width: 34, height: 34, bgcolor: "#ebe9fb", color: "primary.main", fontSize: 13, fontWeight: 800 }}>{initials}</Avatar></IconButton></Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)} transformOrigin={{ horizontal: "right", vertical: "top" }} anchorOrigin={{ horizontal: "right", vertical: "bottom" }} PaperProps={{ sx: { mt: 1, minWidth: 220 } }}>
        <Box sx={{ px: 2, py: 1 }}><Typography fontWeight={750}>Administrator</Typography>{email && <Typography variant="body2" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>{email}</Typography>}</Box><Divider />
        <MenuItem onClick={() => setAnchorEl(null)}><ListItemIcon><PersonOutlineRoundedIcon fontSize="small" /></ListItemIcon>Profile</MenuItem>
        <MenuItem onClick={logout}><ListItemIcon><LogoutRoundedIcon fontSize="small" /></ListItemIcon>Sign out</MenuItem>
      </Menu>
    </Toolbar>
  </AppBar>;
}
